// Boundary-aware route matching: true for an exact match or a nested sub-path,
// false for an unrelated route that merely shares the same string prefix
// (e.g. "/admin/tasks" must not match "/admin/taskStatuses").
export const matchesRoutePrefix = (pathname = "", route = "") => {
  const normalizedPath = pathname.toLowerCase();
  const normalizedRoute = route.toLowerCase();
  return normalizedPath === normalizedRoute || normalizedPath.startsWith(`${normalizedRoute}/`);
};
